// 部品 ボタン左右均等割り用棚
import React from 'react';
import { Row, Col } from 'react-bootstrap';

interface Props {
  children: React.ReactNode;
}

const RowJustifyButton: React.FC<Props> = ({ children }) => {
  return (
    <Row className="row-justify-button">
      <Col className="text-center">{children}</Col>
    </Row>
  );
};

export default RowJustifyButton;
